import SimpleDate from "app/common/classes/simple-date"

export enum EncashmentsAction {
  Reject = 'reject',
  Accept = 'accept'
}


export type EncashmentsStatusAction = {
  salePointId: string,              // точка продаж
  date: SimpleDate,
  action: EncashmentsAction.Reject | EncashmentsAction.Accept,        // тип операции, accept|reject
  comment?: string
}


export const isEncashmentionAction = (params: any): params is EncashmentsStatusAction => {
  const { salePointId, date, comment, action } = params
  return !!(salePointId && date && (
    action === EncashmentsAction.Reject && comment
    || action === EncashmentsAction.Accept
  ))
}


export type OperationResultType = {
  operationType: EncashmentsAction,
  sum: number
}
